import { MediaGallery, TechnologicalSolution } from "@/@types";
import { MediaGalleryResponse, TechnologicalSolutionResponse } from "../../technologicalSolutions/models/TechnologicalSolutionsResponse";

export function mapTechnologicalSolution(data: TechnologicalSolutionResponse): TechnologicalSolution {

  return {
    title: data.title,
    subtitle: data.subtitle,
    description: data.description,
    content: data.content,
    banner: data.banner,
    coverImage: data.cover_image,
    brochure: data.brochure,
    url: data.url,
    slug: data.slug,
    prefooter: data.prefooter,
    solutionType: data.solution_type,
    mediaGallery: mapMediaGallery(data.media_gallery),
    childrenSolutions: data.children_solutions?.map(mapTechnologicalSolution),
    isBlank: data.is_blank,
    order: data.order,
    statusId: data.status_id,
    solutionTypeId: data.solution_type_id,
    metaTitle: data.meta_title,
    metaDescription: data.meta_description,
    metaKeywords: data.meta_keywords,
  }
}

function mapMediaGallery(data: MediaGalleryResponse): MediaGallery {
  return data.map((item) => ({
    title: item.title,
    media: item.media,
    mediaType: item.media_type,
    mediaLocal: item.media_local,
  }));
}
